<template>
  <div class="page">
    <div class="nav">
      <div class="nav-scroll">
        <span :class="selected == '资金计划' ? 'selected' : ''" @click="toggle('资金计划')">资金计划</span>
        <span>|</span>
        <span :class="selected == '授信额度' ? 'selected' : ''" @click="toggle('授信额度')">授信额度</span>
        <span>|</span>
        <span :class="selected == '库存天数' ? 'selected' : ''" @click="toggle('库存天数')">库存天数</span>
        <span>|</span>
        <span :class="selected == '应付天数' ? 'selected' : ''" @click="toggle('应付天数')">应付天数</span>
        <span>|</span>
        <span :class="selected == '应收天数' ? 'selected' : ''" @click="toggle('应收天数')">应收天数</span>
      </div>
    </div>

    <FinanceFundplan v-if="selected === '资金计划'" />

    <Credit v-if="selected === '授信额度'" />

    <Stock v-if="selected === '库存天数'"/>

    <Pay v-if="selected === '应付天数'"/>

    <Receive v-if="selected === '应收天数'"/>

  </div>
</template>

<script>
import FinanceFundplan from "@/components/FinanceFundplan/FinanceFundplan.vue";
import Credit from "@/components/FinanceFundplan/Credit.vue";
import Stock from "@/components/FinanceFundplan/Stock.vue";
import Pay from "@/components/FinanceFundplan/Pay.vue";
import Receive from "@/components/FinanceFundplan/Receive.vue";

export default {
  components: {
    FinanceFundplan,
    Credit,
    Stock,
    Pay,
    Receive
  },
  data() {
    return {
      selected: '资金计划'
    };
  },
  methods: {
    toggle(val) {
      this.selected = val
    }
  }
};
</script>

<style scoped>
.nav {
  overflow-x: scroll;
}
.nav-scroll {
  width: 150%;
  padding: 10px 20px;
  display: flex;
  justify-content: space-around;
  background: var(--weui-BG);
}
.nav .selected {
  color: #38559F;
}
</style>